import { useContext, useState } from "react";
import { Box, Button, Drawer } from "@mui/material";
import TicketsList from "./TicketsList";
import ActiveTicket from "./ActiveTicket";

import ITicket from "./@type";
import { AppContext } from "../../scripts/context/App";

interface Props {
  window?: () => Window;
}
const drawerWidth = 240;

export default function SupportTickets(props: Props) {
  const { user } = useContext(AppContext);
  const { window } = props;
  const [mobileOpen, setMobileOpen] = useState(false);
  const [activeTicket, setActiveTicket] = useState<ITicket>({
    sent_time: "",
    ticket_id: 0,
    title: "",
    unread_ticket: true,
    user_avatar: "",
    user_name: "",
  });

  const handleDrawerToggle = () => setMobileOpen(!mobileOpen);
  const container =
    window !== undefined ? () => window().document.body : undefined;

  if (!user.permissions.includes("view_ticket")) return (
    <Box>
      <h1>You don't have permission to view tickets</h1>
    </Box>
  );

  return (
    <>
      <Button
        sx={{ display: { xs: "block", sm: "none" } }}
        onClick={handleDrawerToggle}
      >
        Open List
      </Button>
      <Box sx={{ display: "flex", width: "100%" }}>
        <TicketsList
          setActiveTicket={setActiveTicket}
          activeTicketId={activeTicket.ticket_id}
          searchStyles={{ display: { xs: "none", sm: "flex" } }}
          sx={{
            display: { xs: "none", sm: "block" },
            minWidth: "300px",
            maxWidth: "300px",
            borderInlineEnd: "1px solid #e0e0e0",
          }}
          close={() => { }}
        />

        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            width: "300px",
            "& .MuiDrawer-paper": { boxSizing: "border-box", width: "300px", maxHeight: "530px"},
          }}
        >
          <TicketsList
            activeTicketId={activeTicket.ticket_id}
            setActiveTicket={setActiveTicket}
            // sx={{ height: "100vh" }}
            close={() => setMobileOpen(false)}
            isMobile
          />
        </Drawer>

        {activeTicket && (
          <Box sx={{ width: "100%" }}>
            <ActiveTicket ticket={activeTicket} />
          </Box>
        )}
      </Box>
    </>
  );
}
